import React from 'react';
import { Grid } from "@mui/material";
import cx from 'classnames';
import { Pill } from 'Components';

/**
 * Renders Unit/Driver selection pills
 */
const EntityTypeSelector = ({
    entities,
    entity,
    onChangeEntity,
    onChange,
    entityButtonClass,
    messages
}) => {
    const availableEntities = [
        { id: "Unit", label: messages['entityUnitDriverSelector_units'] },
        { id: "Driver", label: messages['entityUnitDriverSelector_drivers'] },
    ];

    const filteredEntities = availableEntities?.filter(ae => entities?.includes(ae?.id));

    if (!filteredEntities || filteredEntities.length === 0) {
        return null;
    }

    return (
        <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
            spacing={1}
            className={cx("entity-type-selector", entityButtonClass)}
        >
            {filteredEntities.map((newEntity, index) => (
                <Grid item xs key={index}>
                    <Pill
                        textField="label"
                        item={newEntity}
                        outlined={newEntity?.id !== entity?.id}
                        onClick={() => {
                            if (newEntity?.id !== entity?.id) {
                                if (onChangeEntity) onChangeEntity(newEntity);
                                if (onChange) onChange([], newEntity);
                            }
                        }}
                        className="entity-type-selector__pill"
                        colorField="default"
                        colorSelection="005bf8"
                    />
                </Grid>
            ))}
        </Grid>
    );
};

export default EntityTypeSelector;

